"use client";

import type { ReactNode } from "react";

import Burger from "@/assets/svg/24/Burger";
import Close from "@/assets/svg/24/Close";
import Modal from "@/components/atoms/Modal";

import styles from "./header.module.css";
import useMenuModal, { menuModalName } from "./useMenuModal";

type Props = {
  children?: ReactNode;
};

const BurgerMenu = ({ children }: Props) => {
  const { isOpen, openModal, closeModal } = useMenuModal();
  return (
    <>
      <button
        className={`${styles.icon} ${styles.burger} ${
          isOpen ? styles.hidden : ""
        }`}
        onClick={openModal}
        aria-label="Open menu"
      >
        <Burger />
      </button>
      <button
        className={`${styles.icon} ${styles.close} ${
          !isOpen ? styles.hidden : ""
        }`}
        onClick={closeModal}
        aria-label="Close menu"
      >
        <Close />
        <Modal modalName={menuModalName} isMenu={true}>
          {children}
        </Modal>
      </button>
    </>
  );
};

export default BurgerMenu;
